<div class="layout-container overflow-hidden" [ngClass]="containerClass"> 
    @if(authService.isAuthenticatedComputedSignal() && !authService.isInitialLoginLoadComputedSignal() && !isSuperAdminScreen) {  
        
        <div>
            <app-sidebar [isSuperAdminScreen]="false"></app-sidebar>
            <div class=" sticky top-0 z-50 layout-header">
                <app-topbar [isSuperAdminScreen]="false"></app-topbar>
                <app-breadcrumb class="content-breadcrumb"></app-breadcrumb>
    
            </div>
            <div class="layout-content-wrapper">            
                <div class="layout-content">
                    <router-outlet></router-outlet>
                </div>
            </div>
            
            <app-profilemenu></app-profilemenu>
            <lib-tenant-selection-sidebar></lib-tenant-selection-sidebar>
        </div>
    }
    @else if (authService.isAuthenticatedComputedSignal() &&
            !authService.isInitialLoginLoadComputedSignal() &&
            authService.isCodyAdministratorComputedSignal() &&
            isSuperAdminScreen) {
        <app-sidebar [isSuperAdminScreen]="true"></app-sidebar> 
        <div class=" sticky top-0 z-50 layout-header">
            <app-topbar [isSuperAdminScreen]="true"></app-topbar>
        </div>
        <div class="layout-content-wrapper">            
            <div class="layout-content">
                <router-outlet></router-outlet>
            </div>
        </div>
    }
    @else {
        <!-- Login Page and Tenant/Agency Selection -->
        <router-outlet></router-outlet>
    }
    <app-themes></app-themes>
    <div class="layout-mask"></div>
</div>
<lib-notification-feature-common-notification></lib-notification-feature-common-notification>